export const STATUS_CATEGORY_FIELD_GQL_TYPE = 'JiraStatusCategoryField';
